import React, { useEffect, useState } from 'react'
import { IBaseDynamicFormElement, ISelectFieldSingleItem } from '../Form/DynamicForm'
import { Avatar, IconButton, InputLabel, ListSubheader, MenuItem, Select } from '@mui/material'
import { useDispatch } from 'react-redux'
import CategoriesApp, { ICategoryModel } from '../../features/categories/CategoriesApp'
import GenerateIcon from '../GenerateIcon'
import CategoriesList from '../../features/categories/CategoriesList'
import BasicModalWindow from '../BasicModalWIndow'
import BaseApp from '../../features/BaseApp'
import { IAxiosDefaultDataObject } from '../../config'
import { handleRequestError } from '../../services/api'

interface ISelectedDynamicItemBoxProps {
    id: number,
    title: string,
    thumbnail: string,
    resetItem: (id: number) => void
}

function SelectedDynamicItemBox(props: ISelectedDynamicItemBoxProps){

    const { id, title, thumbnail, resetItem } = props

    return(
        <div className="selected-item-box-field">
            <div className="content-of-selected-item-box-field">

                <div className="thumb-of-selected-item-box-field">
                    <div className="content-of-thumb-of-selected-item-box-field">
                        <Avatar src={thumbnail}>
                            <GenerateIcon icon="image" />
                        </Avatar>
                    </div>
                </div>

                <div className="text-of-selected-item-box-field">
                    <div className="content-of-text-of-selected-item-box-field">
                        <h3>{title}</h3>
                    </div>
                </div>

                <div className="action-button-of-selected-item-box-field">
                    <div className="content-of-action-button-of-selected-item-box-field">
                        <IconButton color="error" onClick={() => resetItem(id)}>
                            <GenerateIcon icon="close" />
                        </IconButton>
                    </div>
                </div>

            </div>
        </div>
    )
}

interface ICategorySelectFieldElementProps extends IBaseDynamicFormElement{
    
}

export default function CategorySelectFieldElement(props: ICategorySelectFieldElementProps) {

    const dispatch = useDispatch()

    const { id, label, fullWidth, handleOnChange, data, displayForItem, addNoneItem, selectLabel, disabled, disableAddNewItem, enableGroups } = props

    const categoriesApp = new CategoriesApp()

    const [item, setItem] = useState<IAxiosDefaultDataObject | null>()

    const [open, setOpen] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const appClass = categoriesApp

    const selectedItem: number = data.value

    /**
     * Handle close modal
     */
    const handleCloseModal = () => setOpen(false)

    /**
     * Handle open modal
     */
    const handleOpenModal = () => setOpen(true)

    /**
     * Handle change
     */
    const handleChange = (id: number | null) => {
        props.handleOnChange(props.id, id)
    }

   /**
     * Load selected item
     */
    const loadItem = () => {
        if (!selectedItem){
            setItem(null)
            return;
        }

        setLoading(true)
        appClass.singleInstanceDetails(selectedItem)
            .then(response => {
                setItem(response.data)
                setLoading(false)
                handleChange(response.data.id)
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })
    }

    useEffect(() => {
        loadItem()
    }, [selectedItem])

    const handleCategorySelect = (category: ICategoryModel) => {
        handleChange(category.id)
        handleCloseModal()
    }

    /**
     * No item selected
     */
    const noItemSelected = () => {
        return(
            <span className="no-item-selected-box" onClick={() => setOpen(true)}>{selectLabel ? selectLabel : "Select Category"}</span>
        )
    }

    /**
     * Loading
     */
    const loadingBlock = () => {
        return(
            <span className="no-item-selected-box">Loading...</span>
        )
    }

    const handleAfterAddNew = () => {
    }


    return(
        <div className="dynamic-model-elem-select-container">

            <BasicModalWindow
                shown={open}
                handleClose={handleCloseModal}
                size="md"
                actionButtons={[
                    {
                        label: "Close",
                        onClick: handleCloseModal,
                        color: "error"
                    }
                ]}
                actionButtonsBottom
                showHeader
                title={selectLabel ? selectLabel : "Select"}
            >
                <CategoriesList 
                    handleCategorySelect={handleCategorySelect} 
                    disableAddNew={disableAddNewItem}
                    enableGroups={enableGroups}
                />
            </BasicModalWindow>

            <div className={disabled ? "selected-item-field-container disabled" : "selected-item-field-container"}>
                <div className="content-of-selected-item-field-container">
                    {label && <div className="label-of-selected-item-field-container">{label}</div>}
                    {loading ? loadingBlock() : item !== null ? <SelectedDynamicItemBox id={item ? item.id : 0} title={item ? item.title : ""} thumbnail={item ? item.thumbnail : ""} resetItem={(id) => handleChange(0)} /> : noItemSelected()}
                </div>
            </div>

        </div>
    )
}